import { AppContent } from '../AppContent';
import lloydsWarning from '../../assets/common/lloyds-warning.svg';

const idvHardFailure: AppContent['idvHardFailure'] = {
  idvHardFailureContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'We couldn’t verify you',
      somethingWentWrong: 'Something went wrong when we tried to verify your details.',
      imageSrc: lloydsWarning,
      imageAltText: 'We couldn’t verify you',
      backToWebsiteButton: 'Back to lloydsbank.com',
      backToWebsiteLink:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default idvHardFailure;
